<template>
  <a-layout>
    <a-space>
      <a-button type="primary" @click="preview">{{ $t('button.previewShipmentPrint') }}</a-button>
      <a-button type="primary" @click="printOrder">{{ $t('button.printShipmentOrder') }}</a-button>
      <a-button type="primary" @click="printDiff">{{ $t('button.printShipmentDifference') }}</a-button>
      <a-button type="primary" @click="query">{{ $t('button.query') }}</a-button>
      <a-button type="primary" @click="reset">{{ $t('button.reset') }}</a-button>
    </a-space>
    <deliver-print-order ref="deliverPrintOrder" @rowClick="rowClick" @reset="detailReset"/>
    <deliver-print-detail ref="deliverPrintDetail" />
  </a-layout>
</template>

<script>
import DeliverPrintOrder from '@/views/outbound/order_print/DeliverPrintOrder.vue'
import DeliverPrintDetail from '@/views/outbound/order_print/DeliverPrintDetail.vue'

export default {
  name: 'DeliverPrint',
  components: { DeliverPrintDetail, DeliverPrintOrder},
  methods: {
    rowClick(orderId) {
      this.$refs.deliverPrintDetail.getData(orderId)
    },
    query() {
      this.$refs.deliverPrintOrder.getData()
    },
    reset() {
      this.$refs.deliverPrintDetail.reset()
      this.$refs.deliverPrintOrder.reset()
    },
    detailReset(){
      this.$refs.deliverPrintDetail.reset()
    },
    preview() {
      this.$refs.deliverPrintOrder.preview()
    },
    printOrder() {
      this.$refs.deliverPrintOrder.printOrder()
    },
    printDiff() {
      this.$refs.deliverPrintOrder.printDiff()
    }
  }
}
</script>
